import { BtButton } from '@linqpal/components/src/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface FooterProps {
  onPress: () => Promise<void>
  styles?: any
}

export const FooterRedirectBackButton: React.FC<FooterProps> = ({
  onPress,
  styles,
}) => {
  const { t } = useTranslation('global')

  return (
    <View
      style={
        styles
          ? styles
          : {
              paddingHorizontal: 4,
              paddingVertical: 16,
              justifyContent: 'center',
            }
      }
    >
      <BtButton
        onPress={onPress}
        testID="IntegrationRedirectBack"
        style={{ height: 55 }}
      >
        {t('integrations.buttons.redirect-back')}
      </BtButton>
    </View>
  )
}
